import { render } from "./StudentUsers.vue?vue&type=template&id=018bbcb3&scoped=true"
import script from "./StudentUsers.vue?vue&type=script&lang=js"
export * from "./StudentUsers.vue?vue&type=script&lang=js"

import "./StudentUsers.vue?vue&type=style&index=0&id=018bbcb3&scoped=true&lang=css"
import "./StudentUsers.vue?vue&type=style&index=1&id=018bbcb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018bbcb3"]])

export default __exports__